import * as React from 'react';
import { withRouter } from 'react-router';
import ReactHtmlParser from 'react-html-parser';
import withStyles from 'react-jss';
import { StylesProps, RouterProps } from 'src/Library/Types';
import { getFormattedDateTime } from 'src/Library/Helper';
import { getAirCargoDetailsRoute, getRFQPlanDetailRoute, getShipmentsListRoute } from 'src/routing/utils';
import { SHIPMENT_TYPE } from '../Container/ContainerUtils';
import { OrgTypes } from 'src/Library/Constants';
import { AirCargoResourceType, NotificationLabelColor, SourceObjectType } from './Notifications.interfaces';
import classnames from 'classnames';
import { Col, Row } from 'antd';
const styles = (theme) => ({
  contentStyleModal: {
    fontSize: '12px',
    color: '#333333',
    paddingRight: '8px',
    width:'60%'
  },
  contentStylePage: {
    fontSize: '14px',
    color: '#333333',
  },
  linkHover: {
    '&:hover': {
      textDecoration: 'underline !important',
    }
  },
  notifAndDotStyle: {
    display: 'flex',
    flexDirection: 'row',
  },
  notifStyleForPage: {
    paddingBottom: '15px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    cursor: 'pointer',
    borderBottom: '1px solid #d9d9d9',
    paddingLeft: '10px',
  },
  notifStyleForModal: {
    padding: '16px 0px 16px 0px',
    cursor: 'pointer',
    borderBottom: '1px solid #d9d9d9',
  },
  blueDot: {
    height: '8px',
    width: '8px',
    backgroundColor: '#1890FF',
    borderRadius: '50%',
    display: 'inline-block',
  },
});
interface IProps extends RouterProps, StylesProps<ReturnType<typeof styles>> {
  data: any;
  markNotification: (params?: Object) => any;
  page: string;
}
const NotificationsListView = (props: IProps) => {
  const { classes, data, history, page, markNotification } = props;
  const addAdditionalStyles = data?.sourceObjectType === SourceObjectType.INQUIRY;
 
  const renderNotificationAndDot = () => {
    return (
      <Row>
        <Col span={4} style={{textAlign:'center', marginTop: '8px'}}>
          {renderLabel()}
        </Col>
      <Col span={5} style={{textAlign:'center'}}>
        {renderNotificationTime()}
      </Col>
      <Col span={14} style={{fontSize:'12px'}}>
      {ReactHtmlParser(data?.content)}
        </Col>
      <Col span={1}>{!data?.isRead && <span className={classes.blueDot} />}
      </Col>
      </Row>
    );
  };

  const renderLabel = () => {
    const [labelColor, labelText] = getLabelColorAndText(data?.sourceObjectType);

    return (
      <span style={{backgroundColor: labelColor, padding: '8px', fontSize:'12px'}}>{labelText}</span>
    )
  };

  const getLabelColorAndText = (sourceType: string) => {
    switch (sourceType) { 
      case SourceObjectType.RFQ_PLAN.toString() : return [ NotificationLabelColor.RFQ_PLAN.toString(), 'RFQ' ];
      case SourceObjectType.HAWB.toString() : return [ NotificationLabelColor.HAWB.toString(), 'Air Cargo' ];
      case SourceObjectType.INQUIRY.toString() : return [ NotificationLabelColor.INQUIRY.toString(), 'Procure' ];
      case SourceObjectType.SHIPMENT.toString() : return [ NotificationLabelColor.SHIPMENT.toString(), 'Track' ];
      default : break;
    }
      return ['#FFFFFF', ''];
  }
  
  const renderNotificationTime = () => {
    return (
    <div style={{textAlign:'center'}}>
      <span style={{fontSize: 12, fontWeight: 600}}>{getFormattedDateTime('DD-MMM-YYYY', data?.notificationActivationTime)}</span><br/>
      <span style={{paddingTop: '8px', fontSize: 10}}>{getFormattedDateTime('hh:mm', data?.notificationActivationTime)} Hrs</span>
    </div>
    );
  };

  const handleNotifClick = () => {
    markNotification({ relationId: data?.relationId });
    if (data?.sourceObjectType === SHIPMENT_TYPE.SHIPMENT) {
      const stakeholderType = data?.viewType === OrgTypes.SHIPPER ? 'shipper' : 'ff';
      return history.push(getShipmentsListRoute(stakeholderType), { shipmentId: data?.sourceObjectId, activeTab: 'tasks' });
    } else if (data?.sourceObjectType === SourceObjectType.HAWB) {
      const airCargoResourceType = data?.sourceObjectType === AirCargoResourceType.AIR ? 'airCargo' : 'freightForwarded';
      return history.push(getAirCargoDetailsRoute(airCargoResourceType, data?.sourceObjectId))
    } else if (data?.sourceObjectType === SourceObjectType.RFQ_PLAN) {
      // sourceObjectId is the RFQ plan id for every RFQ notification — route to its detail/line-items page
      return history.push(getRFQPlanDetailRoute(data?.sourceObjectId, 'main'));
    } else return true; // for inquiry href is present in content, to make both href and onClick work

  };

  return <div className={classes.notifStyleForModal} onClick={() => handleNotifClick()}>
    {renderNotificationAndDot()}
  </div>;
};
export default withRouter((withStyles(styles)(NotificationsListView)));